import { useTranslation } from "react-i18next";

/**
 * Skip-to-content link (T50 a11y baseline).
 *
 * Visually hidden until it receives keyboard focus. First Tab from the page
 * load reveals it; Enter jumps focus past the navbar to <main id="main-content">.
 * Mandated by `_docs/01-core/accessibility-baseline.md` §3 Keyboard navigation
 * and WCAG 2.4.1.
 */
export function SkipToContent() {
  const { t } = useTranslation("common");
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded focus:bg-darkBg focus:text-white focus:px-4 focus:py-2 focus:no-underline focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-white"
    >
      {t("a11y.skip_to_content")}
    </a>
  );
}
